module.exports = __webpack_public_path__ + "img/usq.0c1d1d35.png";